import { useRef } from 'react';
import clsx from 'clsx';
import { useClient } from '@ywwwtseng/react-kit';
import { Typography, openTelegramLink } from '@ywwwtseng/tma-react-kit';
import { ChevronRight } from 'lucide-react';
import { ChatPhoto } from './ChatPhoto';
import type { Gift, SelectTgChat } from '@/types';

type Direction = 'horizontal' | 'vertical';

interface ChatProps {
  chat: SelectTgChat;
  className?: string;
  chriveRight?: boolean;
  direction?: Direction;
  card?: boolean;
}

export function Chat({ chat, className, chriveRight = false, direction = 'horizontal', card = true }: ChatProps) {
  const latestGiftRef = useRef<Gift | null>(null);
  const { query } = useClient();

  return (
    <div
      className={clsx('flex items-center gap-2', className, direction === 'vertical' ? 'flex-col' : '', card ? 'card' : '')}
      onClick={async () => {
        if (chat.invite_link) {
          openTelegramLink(chat.invite_link);
          return;
        }

        if (!chat.username) return;

        let gift = latestGiftRef.current;

        if (!gift) {
          const res = await query('chat_latest_gift', { tg_chat_username: chat.username });
          const { data } = res.data as { data: Gift[] };
          gift = data?.[0];
          latestGiftRef.current = gift;
        }

        const message_id = gift?.message_id?.split(':')[1];

        if (message_id) {
          openTelegramLink(`https://t.me/${chat.username}/${message_id}`);
        } else {
          openTelegramLink(`https://t.me/${chat.username}`);
        }
      }}
    >
      <ChatPhoto chat={chat} />
      <Typography className="w-full" size={direction === 'vertical' ? '1' : '2'} textAlign={direction === 'vertical' ? 'center' : 'left'} weight={600}>
        {chat.name}
      </Typography>

      {chriveRight && (
        <ChevronRight
          className="ml-auto text-icon-foreground"
          size={24}
          strokeWidth={1.5}
        />
      )}

    </div>
  );
}
